export const SET_TICKET = "@HELPDESK/SET_TICKET";
export const SET_TICKET_LIST = "@HELPDESK/SET_TICKET_LIST";
export const SET_TICKET_STATS = "@HELPDESK/SET_TICKET_STATS";

export const SET_TICKET_CATEGORY = "@HELPDESK/SET_TICKET_CATEGORY";
export const SET_TICKET_CATEGORY_LIST = "@HELPDESK/SET_TICKET_CATEGORY_LIST";
